import { useState } from 'react';
import { usePleaAttachments } from './usePleaAttachments';
import type { Plea } from '../types';

interface UsePleaDetailOptions {
  agreementUuid: string | undefined;
}

export function usePleaDetail({ agreementUuid }: UsePleaDetailOptions) {
  const [selectedPlea, setSelectedPlea] = useState<Plea | null>(null);
  const attachments = usePleaAttachments(agreementUuid);

  const openView = (plea: Plea) => {
    setSelectedPlea(plea);
    attachments.load(plea);
  };

  const closeView = () => {
    setSelectedPlea(null);
    attachments.reset();
  };

  return {
    selectedPlea,
    viewOpen: selectedPlea !== null,
    openView,
    closeView,
    attachments: attachments.attachments,
    attachmentsLoading: attachments.attachmentsLoading,
    attachmentsError: attachments.attachmentsError,
  };
}
